import type { FeatureCollection } from 'geojson'

import algeriaArea from '@/constants/areas/algeria.json'
import algeriaFilterArea from '@/constants/areas/algeria.simplified.json'
import conusArea from '@/constants/areas/conus.json'
import conusFilterArea from '@/constants/areas/conus.simplified.json'
import moroccoArea from '@/constants/areas/morocco.json'
import moroccoFilterArea from '@/constants/areas/morocco.simplified.json'
import southAmericaArea from '@/constants/areas/south_america.json'
import southAmericaFilterArea from '@/constants/areas/south_america.simplified.json'
import tunisiaArea from '@/constants/areas/tunisia.json'
import tunisiaFilterArea from '@/constants/areas/tunisia.simplified.json'

export default {
  southAmericaArea,
  conusArea,
  tunisiaArea,
  algeriaArea,
  moroccoArea
} as { [y: string]: FeatureCollection }

// Simplified copies of the areas above, sent as the spatial filter of feature service
// queries, where the full-resolution boundaries would make the request parameter huge.
// Generated with: npx mapshaper -i <area>.json -simplify interval=5000 keep-shapes
//   -filter-slivers -o <area>.simplified.json format=geojson precision=0.001
export const filterAreas = {
  southAmericaFilterArea,
  conusFilterArea,
  tunisiaFilterArea,
  algeriaFilterArea,
  moroccoFilterArea
} as { [y: string]: FeatureCollection }
